import { ParsedQuery, parse } from "query-string";
import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const excludedSearchParams = ["platformName", "displayText"];

const useFilteredQueryParams = (keepContinue = false): ParsedQuery<string> => {
  const location = useLocation();
  return useMemo(() => {
    const parsed = parse(location.search);

    if (!keepContinue) {
      delete parsed["continue"];
    }

    excludedSearchParams.forEach((key) => {
      delete parsed[key];
    });
    return parsed;
  }, [keepContinue, location.search]);
};

export default useFilteredQueryParams;
